/** Where text goes into a textarea's value. */
interface Params {
  /** The textarea's current value. */
  value: string;
  /** Text to put in. */
  text: string;
  /** Start of the selection; the cursor position when nothing is selected. */
  selectionStart: number;
  /** End of the selection; equal to `selectionStart` when nothing is selected. */
  selectionEnd: number;
}

/** The value with `text` in place of the selection, and the cursor position right after it. */
export const insertAtCursor = ({ value, text, selectionStart, selectionEnd }: Params) => ({
  value: `${value.slice(0, selectionStart)}${text}${value.slice(selectionEnd)}`,
  cursor: selectionStart + text.length
});
